// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3diQp","right":"styles_right__Hg26p"};